import { ToastContainer } from "react-toastify"
import { AboutContent } from "../components/about/AboutContent"
import { AboutInfoContent } from "../components/about/AboutInfoContent"
import { Footer } from "../components/Footer"
import { Header } from "../components/Header"

export const AboutPage = () => {
  return (
    <>
      <ToastContainer autoClose={6000} />
      <div className="main__bg">
        <video autoPlay loop muted playsInline poster="img/bg.jpg" className="fullscreen-bg__video">
          <source src="/img/video_bg.mp4" type="video/mp4" />
        </video>
        <div className="main-box main-about">
          <Header />
          <AboutInfoContent />
        </div>
      </div>

      <AboutContent />

      <Footer isDark={true} />
    </>
  )
}
